module.exports = __webpack_public_path__ + "img/none.2bbb8619.svg";